module.exports = __webpack_public_path__ + "img/ics_o_commodity_v2_active.ff2c1b81.svg";